import media from '@/assets/css/media/media.scss'

export default {
  data () {
    return {
      media: window.matchMedia(media['media-3']).matches ? 'Desktop' : 'Mobile'
    }
  }
}
